/* eslint-disable no-param-reassign */
import * as R from "ramda";

import Interval from "utility/Interval";

import mergeIntervals from "./mergeIntervals";
import sortIntervals from "./sortIntervals";

const startsBeforeStartOf = <T>(a: Interval<T>, b: Interval<T>): boolean => {
	return R.isNil(a[0]) ? !R.isNil(b[0]) : !R.isNil(b[0]) && a[0] < b[0];
};

const endsBeforeStartOf = <T>(a: Interval<T>, b: Interval<T>): boolean => {
	return !R.isNil(a[1]) && !R.isNil(b[0]) && a[1] < b[0];
};

const endsBeforeEndOf = <T>(a: Interval<T>, b: Interval<T>): boolean => {
	return !R.isNil(a[1]) && !R.isNil(b[1]) && a[1] < b[1];
};

const excludeFromIntervals = <T>(
	from: Interval<T>[],
	exclude: Interval<T>[],
	merged?: boolean,
	sorted?: boolean
): Interval<T>[] => {
	if (!merged) {
		from = mergeIntervals(from);
		exclude = mergeIntervals(exclude);
	} else if (!sorted) {
		from = sortIntervals(from);
		exclude = sortIntervals(exclude);
	}

	if (from.length === 0) {
		return [];
	}

	if (exclude.length === 0) {
		return from;
	}

	let result = from;

	for (const exclusion of exclude) {
		const next: Interval<T>[] = [];

		for (const interval of result) {
			if (startsBeforeStartOf(interval, exclusion)) {
				if (endsBeforeStartOf(interval, exclusion)) {
					next.push(interval);
				} else {
					next.push([interval[0], exclusion[0]]);

					if (endsBeforeEndOf(exclusion, interval)) {
						next.push([exclusion[1], interval[1]]);
					}
				}
			} else {
				if (endsBeforeStartOf(exclusion, interval)) {
					next.push(interval);
				} else {
					if (endsBeforeEndOf(exclusion, interval)) {
						next.push([exclusion[1], interval[1]]);
					}
				}
			}
		}

		result = next;
	}

	return result;
};

export default excludeFromIntervals;
